import React, { Component } from "react";

import fiSpreadsheetActions from "../../../actions/fiSpreadsheetActions";
import fiSpreadsheetInputFields from "./fiSpreadsheetInputFields";
import generateEntityCreator from "../../../hocs/generateEntityCreator";

class FiSpreadsheetCreator extends Component {
  componentWillMount() {
    const { initialValues } = this.props;
    const currDate = new Date();

    const initialValues2 = {
      assessorId: 0,
      headersLine: 4,
      sheetName: "Debentures Isentas",
      headers: {
        issuer: "EMISSOR",
        code: "CÓDIGO",
        maturityDate: "VENCIMENTO",
        rating: "RATING",
        agency: "AGÊNCIA",
        rate: "TAXA SUGERIDA",
        rateType: "INDEXADOR",
        // availableQuantity: "QUANTIDADE INDICATIVA",
        // unitPrice: "PREÇO UNITÁRIO",
        grossRoa: "RECEITA ESTIMADA",
      },
    };

    this.DefaultFormWithProps = generateEntityCreator({
      entityActions: fiSpreadsheetActions,
      returnRoutePath: "fi-spreadsheets-listing",
      fields: fiSpreadsheetInputFields,
      submitLabel: "Importar",
      initialValues: initialValues2,
    });
  }

  render() {
    const { DefaultFormWithProps } = this;
    return <DefaultFormWithProps />;
  }
}

export default FiSpreadsheetCreator;
